import React from 'react'
import "./PlannedTrips.css"
import Avatar001 from '../../assets/images/default-avatar-2020-61.jpeg'
import Avatar002 from '../../assets/images/default-avatar-2020-64.jpeg'
import cameraSticker from '../../assets/images/new-icons_camera-icon.svg'
import mountainSticker from '../../assets/images/new-icons_mountain-icon.svg'
import glassSticker from '../../assets/images/new-icons_winecup-icon.svg'
import reviewRating from '../../assets/images/review-rating.svg'
import KboiAvatar from '../../assets/images/default-avatar-2020-21.jpeg'
import mommoImage from '../../assets/images/gallery_0000_planned-trips.jpg'
import MecationImage from '../../assets/images/gallery_0001_planned-trips.jpg'
import birthday30avatar from '../../assets/images/default-avatar-2020-41.jpeg'
import birthdat30Image from '../../assets/images/gallery_0002_planned-trips.jpg'
import Typewriter from 'typewriter-effect';
import Marquee from "react-fast-marquee";


const PlannedTrips = () => {



return (
    <> 
            {/* Desktop View    */}
            <div className='uk-visible@l'>

            {/* Section One */}
            <div className="uk-section uk-flex ">
                <div className="uk-width-1-1">
                    <div className="uk-container "> 


                        <div className="uk-width-2-5@m uk-width-1-1@s">

                            <div className='trip-heading-display trip-ultra copy-margin-bottom  uk-visible@s'>      
                            We created over 6MM custom itineraries this year.
                            </div>

                            <div className='trip-heading-one uk-visible@s'>
                            We took Grandma to the club.
                            </div>

                            {/* mobile view */}

                            <div className='trip-heading-display trip-ultra copy-margin-bottom uk-text-center  uk-hidden@s'>      
                                    We planned over 6MM new Trips this year.
                            </div>
                            



                        </div>


                        <div className="uk-grid-collapse uk-grid-margin uk-grid uk-margin-remove-top move-up-moblie" uk-grid="">

                            <div className="uk-width-1-2@m uk-first-column">


                            <div className="mommom-review-top top-z">

            <div className='uk-card uk-card-border trips-review-container'>

                    <div className='trips-user-avatar'>
                        <img src={Avatar001} alt="Emma's Avatar" className=''/>
                    </div>
                    
                    <div className='trips-review-title'>
                            MomMom’s Bach Bash
                    </div>

                    <div className='trips-review-user'>
                    By <span className='trip-medium'>  Emma </span>
                    </div>

                    <div className='trips-review-date'>
                    22 items • Mar 2022
                    </div>
            </div>

            </div>




                            </div>

                            <div className="uk-width-1-2@m">

                                        <div className="uk-panel uk-width-1-1">   

                                            <div className='trip-heading-one uk-text-center uk-hidden@s uk-margin-bottom'>
                                            We took Grandma to the club
                                            </div>         

                                            <div className="uk-flex uk-flex-right trips-image" >
                                                <img src={mommoImage} alt="People Smiling" className=''/> 
                                            </div>

                                            <div>
                                                
                                            </div>

                                            <div className="trips-camera-sticker">
                                                <img src={cameraSticker} alt="Badge" className=''/>
                                            </div>


                                    </div>



                            </div>


                            </div>


                    </div>
                </div>
            </div>


            {/* Section two  */}
            <div className="uk-section uk-padding-remove-top " >
                <div className="uk-width-1-1">
                    <div className="uk-container move-down-mobile">

                        <div className='trip-heading-one copy-margin-bottom uk-visible@s'>
                        Took solo vacays.
                        </div>

                        <div className='trip-heading-one copy-margin-bottom uk-text-center uk-hidden@s'>
                        Took solo vacays.
                        </div>

                            <div className="uk-grid-margin uk-grid">

                                <div className="uk-width-1-2@m">

                                    <div className="mecation-image trips-image uk-animation-slide-bottom-medium" >
                                    <img src={MecationImage} alt="People Smiling" className=''/>        
                                    </div>


                                    <div className="mountain-badge">
                                        <img src={mountainSticker} alt="Badge" className=''/>
                                    </div>

                                </div>


                                <div className="uk-width-1-2@m">
                                <div className="mecation-review uk-animation-slide-top-medium">

            <div className='uk-card uk-card-border trips-review-container'>

                    <div className='trips-user-avatar'>
                        <img src={Avatar002} alt="Bangkok Food" className=''/>
                    </div>
                    
                    <div className='review-text trips-review-title'>
                    MEcation GETAWAY
                    </div>

                    <div className='trips-review-user'>
                    By <span className='trip-medium'> Virginia L</span>
                    </div>

                    <div className='trips-review-date'>
                    22 items • May 2022
                    </div>

            </div>

            </div>
                                

                                </div>

                            </div>


                    </div>
                </div>
            </div>
            {/* End of Section Two */}


            {/* Start of Section Three */}

            <div className="uk-section  uk-padding-remove-bottom">
                <div className="uk-width-1-1">
                    <div className="uk-container "> 

                        <div className=" uk-grid-margin uk-grid uk-margin-small-top" uk-grid="">

                            <div className="uk-width-1-2@m uk-first-column">

                                <div className='trip-heading-one uk-visible@s trip-title-move-down'>
                                And celebrated 30+2.
                                </div>

                                <div className='trip-heading-one uk-hidden@s uk-text-center'>
                                And celebrated 30+2.
                                </div>

                            </div>

                            <div className="uk-width-1-2@m">

                                        <div className="uk-panel uk-width-1-1">            

                                            <div className="uk-margin uk-flex uk-flex-right trips-image" >
                                                <img src={birthdat30Image} alt="People Smiling" className=''/> 
                                            </div>

                                            <div className="trips-glass-sticker z-5">
                                                <img src={glassSticker} alt="Badge" className=''/>
                                            </div>

                                            <div className="mommom-review">

                                                <div className='uk-card uk-card-border trips-review-container'>

                                                        <div className='user-avatar'>
                                                            <img src={birthday30avatar} alt="Emma's Avatar" className=''/>
                                                        </div>
                                                        
                                                        <div className='trips-review-title'>
                                                        30+2 Birthday
                                                        </div>

                                                        <div className='trips-review-user'>
                                                        By <span className='trip-medium'> Lady R </span>
                                                        </div>

                                                        <div className='trips-review-date'>
                                                        37 items • Jul 2022
                                                        </div>
                                                </div>

                                            </div>



                                    </div>



                            </div>


                            </div>


                    </div>
                </div>
            </div>
            {/* End Of Section Three */}



            {/* Section Four*/}
            <div className="uk-section uk-padding-remove-top " uk-height-viewport="offset-bottom:10" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: true;">
                <div className="uk-width-1-1">
                    <div className="uk-container">

                            <div className="uk-width-1-2@m uk-width-1-1@s" uk-scrollspy-class="uk-animation-slide-bottom-medium">
                                    <div className='trip-heading-display trip-ultra copy-margin-bottom  uk-visible@s'>      
                                    We came home with lots to share, all to help travelers find what's good.
                                    </div>

                                    {/* <div className='trip-heading-one uk-visible@s'>
                                    ...or not so good.
                                    </div> */}

                                    {/* mobile view */}

                                    <div className='trip-heading-display trip-ultra copy-margin-bottom uk-text-center  uk-hidden@s'>      
                                    We came home with lots to share, all to help travelers find what's good.
                                    </div>

                                    {/* <div className='trip-heading-one uk-text-center uk-hidden@s'>
                                    ...or not so good.
                                    </div> */}
                            </div>

                            <div className="tm-grid-expand uk-margin-small-top uk-grid" uk-scrollspy-class="uk-animation-slide-bottom-medium">
                                <div className="uk-width-1-4@m">

                                </div>

                                <div className="uk-width-3-4@m uk-flex uk-flex-center uk-flex-right">

                                        <div className="move-down-mobile">

                                            <div className='uk-card uk-card-border location-review-container'>

                                                    <div className='reviewfull-rating'>
                                                                <img src={reviewRating} alt="Star Rating" className=''/>
                                                    </div>

                                                    <div className='location-review-content'>

                                                        <Typewriter
                                                        options={{
                                                            strings:"The building is just stunning, we were so WOWED by the architecture, you will never see something similar in your life. For sure must visit.",
                                                            autoStart: true,
                                                            loop: true,
                                                        }}
                                                        />
                                                    

                                                    </div>

                                                    <div className="uk-flex uk-flex-middle location-review-user-info">
                                                            <div className="uk-margin-small-left location-review-user">
                                                                @Kboik841
                                                            </div>
                                                            <div className=" uk-flex-first">
                                                                <img src={KboiAvatar} alt="User Avatar" className='location-avatar uk-border-circle'/>
                                                            </div>
                                                    </div>
                                                            



                                                    <div className='location-review-footer'>
                                                    Review of Basilica de la Sagrada Familia 
                                                    </div>

                                            </div>

                                        </div>



                                </div>

                            </div>
                            




                    </div>
                </div>
            </div>


            <div className=''>

                    <div className="trip-heading-one trip-ultra thick-borders uk-text-center text-no-wrap trip-background-moss">

                    <Marquee
                    gradient={false}
                    style={{background: "transparent"}}
                    direction="right"
                    speed={50} loop={0}>  
                    <span className="trip-ultra"> • 16MM five-bubble reviews written • 22MM helpful votes given • 387K forum threads created </span> </Marquee>

                    </div>

            </div>
            {/* End of Section Four */}

            </div>
            {/* End Of Desktop View */}


{/* Mobile View */}
            <div className='uk-section uk-hidden@l uk-flex uk-flex-center uk-hidden@l'>
                <div className='uk-container'>

                <div className='trip-heading-display trip-ultra' >      
                We created over 6MM custom itineraries this year.
                </div>


{/* Info One */}
                <div className='info-holder uk-margin-large-top '>
                    <div>

                        <div className='uk-width-1-1'>


                            <div className='camera-sticker-holder top-z uk-position-absolute'>
                                <img src={cameraSticker} alt="Badge" className=''/>
                            </div>

                            <div className='trip-heading-one uk-margin-bottom'>
                                 We took Grandma<br/> to the club.
                            </div>

                            <div className='uk-margin-medium-left image-sticker-container uk-flex uk-flex-right'>
                                    <div className="trips-image" >
                                        <img src={mommoImage} alt="People Smiling" className=''/> 
                                    </div>
                            </div>
                            

                            <div className='uk-flex uk-flex-left uk-margin-medium-right'>
                                <div className='reviews-move-up'>
                                    <div className="uk-flex uk-flex-center top-z">

                                        <div className='uk-card uk-card-border planned-trip-card'>

                                                <div className='trips-user-avatar'>
                                                    <img src={Avatar001} alt="Emma's Avatar" className=''/>
                                                </div>
                                                
                                                <div className='trips-review-title'>
                                                        MomMom’s Bach Bash
                                                </div>

                                                <div className='trips-review-user'>
                                                By <span className='trip-medium'>  Emma </span>
                                                </div>

                                                <div className='trips-review-date'>
                                                22 items • Mar 2022
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

{/* Info Two */}
                <div className='info-holder uk-margin-large-top'>
                    <div>
                        <div className='uk-width-1-1'>

                            <div className='mountain-sticker-holder top-z uk-position-absolute'>
                                <img src={mountainSticker} alt="Badge" className=''/>
                            </div>

                            <div className='trip-heading-one uk-margin-bottom'>
                                Took solo vacays.
                            </div>

                            <div className='uk-margin-medium-right image-sticker-container uk-flex uk-flex-left'>
                                    <div className="trips-image" >
                                        <img src={MecationImage} alt="People Smiling" className=''/> 
                                    </div>
                            </div>

                            <div className='uk-flex uk-flex-right uk-margin-medium-left'>
                                <div className='reviews-move-up'>
                                    <div className="uk-flex uk-flex-center z-5">

                                        <div className='uk-card uk-card-border planned-trip-card'>

                                                <div className='trips-user-avatar'>
                                                    <img src={Avatar002} alt="Emma's Avatar" className=''/>
                                                </div>
                                                
                                                <div className='trips-review-title'>
                                                MEcation GETAWAY
                                                </div>

                                                <div className='trips-review-user'>
                                                By <span className='trip-medium'> Virginia L</span>
                                                </div>

                                                <div className='trips-review-date'>
                                                22 items • May 2022
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            
                        </div>
                    </div>
                </div>


{/* Info Three */}
                <div className='info-holder uk-margin-large-top'>
                    <div>

                        <div className='uk-width-1-1'>


                            <div className='glass-sticker-holder top-z uk-position-absolute'>
                                <img src={glassSticker} alt="Badge" className=''/>
                            </div>

                            <div className='trip-heading-one uk-margin-bottom'>
                            And celebrated 30+2.
                            </div>

                            <div className='uk-margin-medium-left uk-margin-small-right image-sticker-container uk-flex uk-flex-right'>
                                    <div className="trips-image" >
                                        <img src={birthdat30Image} alt="People Smiling" className=''/> 
                                    </div>
                            </div>
                            

                            <div className='uk-flex uk-flex-left uk-margin-medium-right'>
                                <div className='reviews-move-up'>
                                    <div className="uk-flex uk-flex-center z-5">

                                        <div className='uk-card uk-card-border planned-trip-card'>

                                                <div className='trips-user-avatar'>
                                                    <img src={birthday30avatar} alt="Emma's Avatar" className=''/>
                                                </div>
                                                
                                                <div className='trips-review-title'>
                                                30+2 Birthday
                                                </div>

                                                <div className='trips-review-user'>
                                                By <span className='trip-medium'> Lady R </span>
                                                </div>

                                                <div className='trips-review-date'>
                                                37 items • Jul 2022
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

  
                </div>
            </div>



<div className='uk-section uk-padding-remove-top  uk-hidden@l'>
    <div className=''>
            {/* Section Four*/}

                    <div className="uk-section uk-container uk-padding-remove-bottom uk-width-1-1 uk- uk-margin-bottom" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: true;">
                            
                        <div className="" uk-scrollspy-class="uk-animation-slide-bottom-medium uk-margin-medium-bottom">
                                 <div className='trip-heading-display trip-ultra'>      
                                We came home with lots to share, all to help travelers find what's good.
                                </div>
                        </div>

                        <div  uk-scrollspy-class="uk-animation-slide-bottom-medium uk-margin-medium-bottom" >

                            <div className="uk-flex uk-flex-left">

                                                <div className="">

                                                    <div className='uk-card uk-card-border location-review-container'>

                                                            <div className='reviewfull-rating'>
                                                                        <img src={reviewRating} alt="Star Rating" className=''/>
                                                            </div>

                                                            <div className='location-review-content'>

                                                                <Typewriter
                                                                options={{
                                                                    strings:"The building is just stunning, we were so WOWED by the architecture, you will never see something similar in your life. For sure must visit.",
                                                                    autoStart: true,
                                                                    loop: true,
                                                                }}
                                                                />
                                                            

                                                            </div>

                                                            <div className="uk-flex uk-flex-middle location-review-user-info">
                                                                    <div className="uk-margin-small-left location-review-user">
                                                                        @Kboik841
                                                                    </div>
                                                                    <div className=" uk-flex-first">
                                                                        <img src={KboiAvatar} alt="User Avatar" className='location-avatar uk-border-circle'/>
                                                                    </div>
                                                            </div>
                                                                    



                                                            <div className='location-review-footer'>
                                                            Review of Basilica de la Sagrada Familia 
                                                            </div>

                                                    </div>

                                                </div>

                             </div>

                        </div>
                                    
                    </div>


            <div className=''>
                    <div className="trip-heading-one trip-ultra thick-borders uk-text-center text-no-wrap trip-background-moss">
                        <Marquee
                        gradient={false}
                        style={{background: "transparent"}}
                        direction="right"
                        speed={50} loop={0}>  
                        <span className="trip-ultra"> • 16MM five-bubble reviews written • 22MM helpful votes given • 387K forum threads created </span> 
                        </Marquee>
                    </div>
            </div>

 {/* End of Section Four */}

    </div>
</div>            
{/* End of Mobile View */}

</>

  )
}

export default PlannedTrips